import React from "react";

interface Tab {
  id: string;
  title: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (tab: Tab) => void;
}

const Tabs: React.FC<TabsProps> = ({ tabs = [], activeTab, onChange }) => {
  return (
    <div className="w-full h-10 flex items-center justify-center bg-gray-100 rounded-lg p-1">
      {tabs?.map((tab) => (
        <button
          key={tab?.id}
          type="button"
          className={`flex-1 h-full text-xs font-medium rounded-md px-3 py-1.5 ${
            activeTab === tab?.id
              ? "bg-white shadow-md shadow-black/5"
              : "bg-transparent"
          }`}
          onClick={() => onChange(tab)}
        >
          {tab.title}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
